<template>
    <UiAirportTabs class="apr-section" :blok="blok" />
</template>

<script setup>
defineProps({ blok: Object });
</script>

<style lang="postcss" scoped>
.apr-section {
    @apply flex justify-center px-0;

    &.evenly-center {
        :deep(.container) {
            .tabs {
                .tabs-control {
                    @apply w-full;
                }
                .tab {
                    @apply flex-[1_1_0] mx-0 border-b-2 border-b-[#E9E9F0];
                    &.active {
                        @apply border-b-2 border-b-[var(--underline-color)];
                    }
                }
            }
            .front-section {
                @apply pb-0;
                .container {
                    @apply pb-0;
                }
            }
        }
    }

    :deep(.tabs) {
        > button {
            .iconify {
                @apply text-text-primary-asphalt;
            }
        }
    }

    :deep(.container) {
        @apply py-0 md:px-4 xl:px-0;

        .subtitle {
            @apply whitespace-normal px-4 md:px-0 text-left mb-6 sm:mb-8 text-base text-text-primary-asphalt;
        }
        h3 {
            @apply apr-section-title px-4 md:px-0 text-text-primary-asphalt;
        }

        .tabs {
            @apply px-4 md:px-0 mb-6 md:mb-8 justify-start;
        }

        .tabs-control {
            @apply flex gap-x-6 md:gap-x-8 md:justify-start border-b border-solid border-neutral-light-grey lg:w-[calc(100%-424px)];
        }

        .tab {
            @apply -mb-[1px] md:pb-2.5 px-0 mx-0 border-b-2 border-solid border-transparent text-text-secondary-grey text-base font-semibold;

            &.active {
                @apply border-brand-primary-500 text-brand-primary-500;
            }
        }

        .tab-content {
            @apply py-0 items-start;
            &:before {
                @apply bg-none;
            }

            &.hide-content-tab {
                &:before {
                    @apply content-[""] absolute h-[4.25rem] md:h-0 w-full bottom-0;
                    background: linear-gradient(180deg, rgba(248, 249, 250, 0) 46.35%, #fff 100%);
                }
            }
            .left {
                @apply block text-text-primary-asphalt;
                p {
                    @apply text-text-primary-asphalt text-base font-normal;
                }
            }
        }

        .tabs-content-btn {
            @apply md:hidden flex justify-center mt-4;
            .show-more-btn {
                @apply bg-[transparent] text-link;
            }
        }

        .rich-text-wrapper,
        .tab-content {
            @apply pl-0;
            * {
                @apply whitespace-normal text-base;
            }
            p {
                @apply mb-4;
                &:last-child {
                    @apply mb-0;
                }
            }

            a {
                @apply text-link cursor-pointer;
                &:hover {
                    @apply underline;
                }
            }
            h4,
            h1 {
                @apply text-text-primary-asphalt text-base font-semibold mb-1;
                &:last-child {
                    @apply mb-0;
                }
                &:first-child {
                    @apply md:mt-0 mt-0;
                }
            }
            .left {
                @apply md:px-0;
            }
            .right {
                @apply min-w-[360px] ml-16 -mt-16;
                img {
                    @apply object-contain;
                }
            }
        }
    }
}
</style>
